module.exports = __webpack_public_path__ + "public/images/curve-no-shadow.34984037477782b369f5306c9cbd9dfa.svg";